import React from 'react';
import s from '../../pages/PDV.module.css';

export default function ModalAbrirCaixa({ modalAbrirCaixa, setModalAbrirCaixa, contaAbertura, setContaAbertura, contasAbertura, suprimentoCaixa, setSuprimentoCaixa, erroAbertura, abrindoCaixa, abrirCaixa, setPendingVenda }) {
  if (!modalAbrirCaixa) return null;
  return (
        <div className={s.modalOverlay}>
          <div style={{
            background: '#fff', borderRadius: 10, padding: 28,
            width: 420, maxWidth: '92vw',
            boxShadow: '0 8px 40px rgba(0,0,0,0.3)',
          }}>
            <h3 style={{ margin: '0 0 6px', fontSize: 17, color: '#1e40af' }}>
              🏦 Abertura de Caixa
            </h3>
            <p style={{ margin: '0 0 18px', fontSize: 13, color: '#555' }}>
              Não há caixa aberto. Informe o suprimento inicial e clique em Abrir para prosseguir.
            </p>

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, color: '#444', display: 'block', marginBottom: 4 }}>
                Conta (opcional)
              </label>
              <select
                value={contaAbertura}
                onChange={e => setContaAbertura(e.target.value)}
                style={{
                  width: '100%', padding: '7px 10px', fontSize: 14,
                  border: '1px solid #ccc', borderRadius: 5, boxSizing: 'border-box',
                }}
              >
                <option value="">— sem vínculo de conta —</option>
                {contasAbertura.filter(c => c.tipo === 'caixa').map(c => (
                  <option key={c.id} value={c.id}>{c.nome}</option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 18 }}>
              <label style={{ fontSize: 12, color: '#444', display: 'block', marginBottom: 4 }}>
                Suprimento inicial (R$)
              </label>
              <input
                type="text"
                inputMode="decimal"
                value={suprimentoCaixa}
                onChange={e => setSuprimentoCaixa(e.target.value)}
                onFocus={e => e.target.select()}
                onKeyDown={e => e.key === 'Enter' && abrirCaixa()}
                autoFocus
                placeholder="0,00"
                style={{
                  width: '100%', padding: '9px 12px', fontSize: 20,
                  fontWeight: 'bold', textAlign: 'right',
                  border: '2px solid #93c5fd', borderRadius: 6,
                  boxSizing: 'border-box', color: '#1e40af',
                }}
              />
              <p style={{ margin: '4px 0 0', fontSize: 11, color: '#888' }}>
                Informe o dinheiro em espécie disponível no caixa. Pode ser R$ 0,00.
              </p>
            </div>

            {erroAbertura && (
              <div style={{
                background: '#fee2e2', color: '#b91c1c', borderRadius: 5,
                padding: '6px 10px', fontSize: 13, marginBottom: 12,
              }}>
                {erroAbertura}
              </div>
            )}

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button
                onClick={() => { setModalAbrirCaixa(false); setPendingVenda(false); }}
                disabled={abrindoCaixa}
                style={{
                  padding: '8px 18px', fontSize: 14, cursor: 'pointer',
                  border: '1px solid #ccc', borderRadius: 6, background: '#f5f5f5',
                }}
              >
                Cancelar
              </button>
              <button
                onClick={abrirCaixa}
                disabled={abrindoCaixa}
                style={{
                  padding: '8px 22px', fontSize: 14, fontWeight: 'bold', cursor: 'pointer',
                  border: 'none', borderRadius: 6,
                  background: abrindoCaixa ? '#93c5fd' : '#2563eb', color: '#fff',
                }}
              >
                {abrindoCaixa ? 'Abrindo...' : '✔ Abrir Caixa'}
              </button>
            </div>
          </div>
        </div>
  );
}
